import React from 'react';

import { SkeletonLoader } from 'common/react/components/SkeletonLoader';

/**
 * Displays a loading state for the Team Lineups Last Updated label.
 *
 * @returns The Team Lineups Last Updated label skeleton loader.
 */
export const TLCondensedLastUpdatedSkeleton = () => (
    <>
        <div className="u-hide-until-tablet">
            <div className="team-lineups-condensed-embeddable--skeleton team-lineups__last-updated">
                <SkeletonLoader width={300} height={21} />
            </div>
        </div>
        <div className="u-hide-from-tablet">
            <div className="team-lineups-condensed-embeddable--skeleton team-lineups__last-updated">
                <SkeletonLoader width={300} height={21} />
            </div>
        </div>
    </>
);
